import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-20 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20artistic%20illustration%20of%20a%20cozy%20reading%20nook%20with%20floating%20comic%20book%20pages%20and%20soft%20magical%20glowing%20particles%2C%20warm%20amber%20and%20golden%20tones%2C%20dreamy%20atmosphere%2C%20inviting%20and%20comfortable%20vibe%2C%20subtle%20anime%20aesthetic%20with%20soft%20focus&width=1920&height=600&seq=cta-bg-001&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-black/60"></div>

      <div className="relative z-10 max-w-screen-2xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-4">
          准备好开始你的<span className="text-primary-400">漫画之旅</span>了吗？
        </h2>
        <p className="text-sm md:text-base text-white/70 mb-8 max-w-lg mx-auto">
          加入百万漫迷的行列，在非常爱漫画发现属于你的精彩故事
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/rexue"
            className="px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-lg transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <span className="flex items-center gap-2">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-rocket-line"></i>
              </div>
              免费开始阅读
            </span>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white font-medium rounded-lg border border-white/20 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            了解爱漫画
          </Link>
        </div>
      </div>
    </section>
  );
}